import React from 'react';
import PropTypes from 'prop-types';

const ContactCard = ({ title, children }) => {
    return (
        <div className="col-md-6 mb-4">
            <div className="contact-card">
                <h4 className="contact-card-title">{title}</h4>
                {children}
            </div>
        </div>
    );
};

ContactCard.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

export default ContactCard;